import { useEffect } from 'react';
import { SHOW_DEPRECATION_WARNINGS } from '@bubble-dev/build-config';
export var usePropsSpreadingDeprecationWarning = _ref => {
  var {
    componentName,
    props,
    useInstead,
    removalDate,
    readMore
  } = _ref;
  useEffect(() => {
    if (SHOW_DEPRECATION_WARNINGS && props !== undefined) {
      Object.keys(props).forEach(propName => {
        var deprecationWarning = "BUBBLE-UI DEPRECATION WARNING: '".concat(propName, "' prop of '").concat(componentName, "' is deprecated because we are deprecating props spreading and will be removed");
        if (removalDate) {
          deprecationWarning += " in/by ".concat(removalDate);
        }
        deprecationWarning += ".";
        if (propName === 'style') {
          deprecationWarning += "\nOverriding styles is no longer supported.";
        } else if (useInstead) {
          deprecationWarning += "\nUse '".concat(useInstead, "' prop instead to spread this prop.");
        }
        deprecationWarning += "\nPlease reach out to us via our slack channel (https://klarna.slack.com/archives/C26NV1XAQ) if you think '".concat(propName, "' should be a supported prop of '").concat(componentName, "'.");
        if (readMore) {
          deprecationWarning += "\nRead more on ".concat(readMore);
        }
        console.warn(deprecationWarning);
      });
    }
  }, [componentName, props, readMore, removalDate, useInstead]);
};
//# sourceMappingURL=index.js.map